import Note from '@/models/Note';

const GET_NOTES = 'get_notes';
const GET_NOTES_REQUEST = 'get_notes_request';
const GET_NOTES_SUCCESS = 'get_notes_success';
const GET_NOTES_ERROR = 'get_notes_error';

export { GET_NOTES };

export default {
    state: {
        notes: [],
        loading: false,
        notesErrors: [],
    },
    mutations: {
        [GET_NOTES_REQUEST]: (state) => {
            state.notes = [];
            state.loading = true;
            state.notesErrors = [];
        },
        [GET_NOTES_SUCCESS]: (state, { notes }) => {
            state.notes = notes;
            state.loading = false;
            state.notesErrors = [];
        },
        [GET_NOTES_ERROR]: (state, { errors }) => {
            state.notes = [];
            state.loading = false;
            state.notesErrors = errors;
        },
    },
    actions: {
        [GET_NOTES]: ({ commit, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_NOTES_REQUEST);
            return new Promise((resolve, reject) => {
                const TrajectoryNotes = Note.makeModel(`/trajectories/${trajectoryId}/notes`);
                TrajectoryNotes.collection(params)
                    .then(({items, meta}) => {
                        const notes = items;
                        commit(GET_NOTES_SUCCESS, { notes });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_NOTES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/notes.js